module.exports = __webpack_public_path__ + "img/section3_3.93277659.png";